module.exports = __webpack_public_path__ + "static/media/kurkuribhindimasala.6378362a.jpg";